document.addEventListener('DOMContentLoaded', function() {
    // Manejar el clic en los items del nivel 2 del mega menú
    const megaNavItems = document.querySelectorAll('.mega-nav__item--toggle');
    
    // Función para manejar el comportamiento según el tamaño de pantalla
    function handleMegaNavBehavior() {
      megaNavItems.forEach(item => {
        const link = item.querySelector('.mega-nav__link');
        const submenu = item.querySelector('> .mega-nav__submenu'); // Solo el submenú directo
        
        if (!link || !submenu) return;
        
        // Remover listeners anteriores
        const newLink = link.cloneNode(true);
        link.parentNode.replaceChild(newLink, link);
        
        if (window.innerWidth > 1023) {
          // En desktop: hover muestra submenú, click navega
          newLink.addEventListener('click', function(e) {
            const href = newLink.getAttribute('href');
            if (href && href !== '#' && href !== '') {
              // Permitir navegación normal
              window.location.href = href;
            }
          });
        } else {
          // En móviles: click hace toggle del submenú
          newLink.addEventListener('click', function(e) {
            e.preventDefault();
            
            // Cerrar todos los otros submenús del nivel 2
            document.querySelectorAll('.mega-nav__item--toggle > .mega-nav__submenu.is-active').forEach(menu => {
              if (menu !== submenu) {
                menu.classList.remove('is-active');
                menu.closest('.mega-nav__item--toggle').classList.remove('is-active');
              }
            });
            
            // Toggle del submenú actual
            submenu.classList.toggle('is-active');
            item.classList.toggle('is-active');
          });
        }
      });
    }
    
    // Ejecutar al cargar
    handleMegaNavBehavior();
    
    // Re-ejecutar al redimensionar
    window.addEventListener('resize', handleMegaNavBehavior);

    // Manejar niveles adicionales del megamenú (nivel 4 y 5)
    const level4Items = document.querySelectorAll('.mega-nav__submenu-item-level-4');
    const level5Items = document.querySelectorAll('.mega-nav__submenu-item-level-5');
    
    // Función para manejar el toggle de niveles adicionales
    function handleLevelToggle(items, levelClass) {
      items.forEach(item => {
        const link = item.querySelector(`.mega-nav__submenu-link-${levelClass}`);
        const submenu = item.querySelector(`.mega-nav__submenu-level-${levelClass}`);
        
        if (link && submenu) {
          link.addEventListener('click', function(e) {
            e.preventDefault();
            
            // Cerrar todos los otros submenús del mismo nivel
            document.querySelectorAll(`.mega-nav__submenu-level-${levelClass}.is-active`).forEach(menu => {
              if (menu !== submenu) {
                menu.classList.remove('is-active');
                menu.closest(`.mega-nav__submenu-item-level-${levelClass}`).classList.remove('is-active');
              }
            });
            
            // Toggle del submenú actual
            submenu.classList.toggle('is-active');
            item.classList.toggle('is-active');
          });
        }
      });
    }
    
    // Aplicar manejo de eventos a niveles 4 y 5
    handleLevelToggle(level4Items, 'level-4');
    handleLevelToggle(level5Items, 'level-5');

    // Cerrar el submenú del nivel 2 al hacer clic fuera (solo en móviles)
    document.addEventListener('click', function(e) {
      if (window.innerWidth <= 1023) {
        if (!e.target.closest('.mega-nav__item--toggle') && 
            !e.target.closest('.mega-nav__submenu-item-level-4') && 
            !e.target.closest('.mega-nav__submenu-item-level-5')) {
          
          // Cerrar solo los submenús del nivel 2 y mantener niveles 4 y 5 funcionando
          document.querySelectorAll('.mega-nav__item--toggle > .mega-nav__submenu.is-active').forEach(menu => {
            menu.classList.remove('is-active');
            menu.closest('.mega-nav__item--toggle').classList.remove('is-active');
          });
          
          // Mantener funcionalidad de niveles 4 y 5
          document.querySelectorAll('.mega-nav__submenu-level-4.is-active, .mega-nav__submenu-level-5.is-active').forEach(menu => {
            menu.classList.remove('is-active');
            menu.closest('.mega-nav__submenu-item-level-4, .mega-nav__submenu-item-level-5').classList.remove('is-active');
          });
        }
      }
    });

    // Cerrar submenús al hacer clic en el botón de atrás del menú
    document.querySelectorAll('.main-nav__item--back').forEach(btn => {
      btn.addEventListener('click', function() {
        document.querySelectorAll('.mega-nav__item--toggle.is-active, .mega-nav__submenu-item-level-4.is-active, .mega-nav__submenu-item-level-5.is-active').forEach(menu => {
          menu.classList.remove('is-active');
          menu.closest('.mega-nav__item, .mega-nav__submenu-item-level-4, .mega-nav__submenu-item-level-5').classList.remove('is-active');
        });
      });
    });

    // Manejar navegación por teclado para niveles adicionales
    function handleKeyboardNavigation(items, levelClass) {
      items.forEach(item => {
        const link = item.querySelector(`.mega-nav__submenu-link-${levelClass}`);
        const submenu = item.querySelector(`.mega-nav__submenu-level-${levelClass}`);
        
        if (link && submenu) {
          link.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              link.click();
            }
          });
          
          // Manejar focus para mostrar submenús
          link.addEventListener('focus', function() {
            if (window.innerWidth > 1023) { // Solo en desktop
              submenu.style.opacity = '1';
              submenu.style.visibility = 'visible';
            }
          });
          
          // Manejar blur para ocultar submenús
          submenu.addEventListener('blur', function(e) {
            if (window.innerWidth > 1023) { // Solo en desktop
              if (!submenu.contains(e.relatedTarget)) {
                submenu.style.opacity = '0';
                submenu.style.visibility = 'hidden';
              }
            }
          }, true);
        }
      });
    }
    
    // Aplicar navegación por teclado a niveles 4 y 5
    handleKeyboardNavigation(level4Items, 'level-4');
    handleKeyboardNavigation(level5Items, 'level-5');

    // Manejar paginación de metaobjects
    const paginationLinks = document.querySelectorAll('.mega-nav__pagination-link');
    paginationLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Aquí se puede implementar la lógica de paginación AJAX si es necesario
        // Por ahora, el enlace funcionará normalmente
        window.location.href = this.href;
      });
    });
});